import {Link} from '@primer/react'

export type PreviewStackDescriptionProps = {
  isExtendingExistingStack: boolean
  existingStackNumber?: number | null
  hasOtherNewlyAddedPulls: boolean
}

export function PreviewStackDescription({
  isExtendingExistingStack,
  existingStackNumber,
  hasOtherNewlyAddedPulls,
}: PreviewStackDescriptionProps) {
  const learnMoreLink = (
    <Link inline href="https://gh.io/stacks-overview">
      Learn more about pull request stacks
    </Link>
  )

  if (isExtendingExistingStack && existingStackNumber != null) {
    return (
      <p className="mb-3 fgColor-muted">
        <span>This pull request</span>
        {hasOtherNewlyAddedPulls ? <span> and other pull requests</span> : null}
        <span> can be added to stack #{existingStackNumber}. Review and update the stack when you’re ready. </span>
        {learnMoreLink}
      </p>
    )
  }

  return (
    <p className="mb-3 fgColor-muted">
      This pull request can be stacked with other pull requests. Review and create the stack when you’re ready.{' '}
      {learnMoreLink}
    </p>
  )
}
